import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { GlobalsService } from '../../../../shared/services';

@Component({
  selector: 'app-content-header',
  templateUrl: './content-header.component.html',
  styleUrls: ['./content-header.component.scss']
})
export class ContentHeaderComponent implements OnInit {

    @Input() organization: string;
    @Input() iconHelp: boolean;
    @Output() clickHelp = new EventEmitter();

    constructor(
        private globals: GlobalsService
    ) { }

    ngOnInit() {

    }

    btnHelp() {
        this.clickHelp.emit('ayuda');
    }

}
